import { render, staticRenderFns } from "./MarginSummary.vue?vue&type=template&id=3e6eb328&scoped=true"
import script from "./MarginSummary.vue?vue&type=script&lang=js"
export * from "./MarginSummary.vue?vue&type=script&lang=js"
import style0 from "./MarginSummary.vue?vue&type=style&index=0&id=3e6eb328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6eb328",
  null
  
)

export default component.exports